import React, { useEffect } from "react";
import { Navigate, Outlet } from "react-router-dom";

const PrivateRoute = () => {
  const token = localStorage.getItem("token");


  console.log(" PrivateRoute check:", {
    token: token ? `${token.slice(0, 20)}...` : "NO TOKEN",
    hasToken: !!token,
  });


  if (!token || token.trim() === "") {
    console.log(" NO TOKEN → REDIRECT TO LOGIN");
    return <Navigate to="/" replace />;
  }

  console.log(" TOKEN OK → SHOW DASHBOARD");
  return <Outlet />;
};

export default PrivateRoute;
